module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("The Talented Miss Highsmith")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "page-template.xpgt",
      "rel": "stylesheet",
      "type": "application/vnd.adobe-page-template+xml"
    }
  }), _vm._v(" "), _c('link', {
    attrs: {
      "href": "9780312303754.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('meta', {
    attrs: {
      "content": "text/html; charset=utf-8",
      "http-equiv": "content-type"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "contents",
    attrs: {
      "id": "con01"
    }
  }, [_c('h2', {
    staticClass: "contentsHead",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("•")]), _vm._v(" Contents "), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("•")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/9780312303754_fm01#fm01"
    }
  }, [_vm._v("A Note on Biography")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/9780312303754_ch01#ch01"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1.")]), _vm._v(" How to Begin: Part 1")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/9780312303754_ch02#ch02"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2.")]), _vm._v(" How to Begin: Part 2")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/9780312303754_ch03#ch03"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("3.")]), _vm._v(" A Simple Act of Forgery: Part 1")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/9780312303754_ch04#ch04"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("4.")]), _vm._v(" A Simple Act of Forgery: Part 2")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/9780312303754_ch05#ch05"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("5.")]), _vm._v(" La Mamma: Part 1")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/9780312303754_ch06#ch06"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("6.")]), _vm._v(" La Mamma: Part 2")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_ch07#ch07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("7.")]), _vm._v(" La Mamma: Part 3")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_ch08#ch08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("8.")]), _vm._v(" La Mamma: Part 4")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_ch09#ch09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("9.")]), _vm._v(" Greek Games")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_ch10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("10.")]), _vm._v(" Alter Ego: Part 1")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_ch11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("11.")]), _vm._v(" Alter Ego: Part 2")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_ch12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("12.")]), _vm._v(" Alter Ego: Part 3")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_ch13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("13.")]), _vm._v(" Alter Ego: Part 4")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_ch14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("14.")]), _vm._v(" Alter Ego: Part 5")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_ch15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("15.")]), _vm._v(" Social Studies: Part 1")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_ch16#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("16.")]), _vm._v(" Social Studies: Part 2")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_ch17#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("17.")]), _vm._v(" Les Girls: Part 1")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_ch18#ch18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("18.")]), _vm._v(" Les Girls: Part 2")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_ch19#ch19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("19.")]), _vm._v(" Les Girls: Part 3")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_ch20#ch20",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("20.")]), _vm._v(" Les Girls: Part 4")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_ch21#ch21",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("21.")]), _vm._v(" Les Girls: Part 5")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_ch22#ch22",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("22.")]), _vm._v(" Les Girls: Part 6")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_ch23#ch23",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("23.")]), _vm._v(" Les Girls: Part 7")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_ch24#ch24",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("24.")]), _vm._v(" Les Girls: Part 8")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_ch25#ch25",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("25.")]), _vm._v(" Les Girls: Part 9")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_ch26#ch26",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("26.")]), _vm._v(" Les Girls: Part 10")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_ch27#ch27",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("27.")]), _vm._v(" Les Girls: Part 11")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_ch28#ch28",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("28.")]), _vm._v(" Les Girls: Part 12")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_ch29#ch29",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("29.")]), _vm._v(" Les Girls: Part 13")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_ch30#ch30",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("30.")]), _vm._v(" Les Girls: Part 14")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_ch31#ch31",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("31.")]), _vm._v(" The Real Romance of Objects: Part 1")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_ch32#ch32",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("32.")]), _vm._v(" The Real Romance of Objects: Part 2")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_ch33#ch33",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("33.")]), _vm._v(" The Real Romance of Objects: Part 3")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_ch34#ch34",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("34.")]), _vm._v(" The Cake that was Shaped Like a Coffin: Part 1")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_ch35#ch35",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("35.")]), _vm._v(" The Cake that was Shaped Like a Coffin: Part 2")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_ch36#ch36",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("36.")]), _vm._v(" The Cake that was Shaped Like a Coffin: Part 3")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_ch37#ch37",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("37.")]), _vm._v(" The Cake that was Shaped Like a Coffin: Part 4")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_ch38#ch38",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("38.")]), _vm._v(" The Cake that was Shaped Like a Coffin: Part 5")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_ch39#ch39",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("39.")]), _vm._v(" The Cake that was Shaped Like a Coffin: Part 6")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_ch40#ch40",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("40.")]), _vm._v(" The Cake that was Shaped Like a Coffin: Part 7")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_ch41#ch41",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("41.")]), _vm._v(" The Cake that was Shaped Like a Coffin: Part 8")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_bm01#bm01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix 1: Just the Facts")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_bm02#bm02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix 2: Patricia Highsmith’s New York")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_bm03#bm03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix 3: Charts, Maps, Diagrams, and Plans")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_bm06#bm06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Selected Bibliography")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_ack01#ack01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_bm04#bm04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes and Sources")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_ind01#ind01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bdaa2a46","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780312303754_con01.vue
// module id = 66
// module chunks = 0